import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/styles/common.scss' // global css
// import '@/assets/styles/web.scss' // zxyh css
import Header from "@/components/Header";
import Footer from "@/components/Footer";

Vue.config.productionTip = false
Vue.component('Header', Header)
Vue.component('Footer', Footer)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
